var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "rolePermissions" } },
    [
      _c("div", { staticClass: "subtitle" }, [_vm._v("Ticket Permissions")]),
      _vm._v(" "),
      _c(
        "v-radio-group",
        {
          attrs: { mandatory: true },
          model: {
            value: _vm.permissions.tickets.value,
            callback: function($$v) {
              _vm.$set(_vm.permissions.tickets, "value", $$v)
            },
            expression: "permissions.tickets.value"
          }
        },
        _vm._l(_vm.permissions.tickets.options, function(perm, key) {
          return _vm.accessLevel >= perm.accessLevel
            ? _c(
                "v-radio",
                {
                  key: key,
                  staticClass: "radio-buttons",
                  attrs: { color: "primary", value: key }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "label-section",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(perm.name))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "desc" }, [
                        _vm._v(_vm._s(perm.description))
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        })
      ),
      _vm._v(" "),
      _vm.accessLevel >= 2
        ? [
            _c("div", { staticClass: "subtitle" }, [
              _vm._v("User Permissions")
            ]),
            _vm._v(" "),
            _c(
              "v-radio-group",
              {
                attrs: { mandatory: true },
                model: {
                  value: _vm.permissions.user.value,
                  callback: function($$v) {
                    _vm.$set(_vm.permissions.user, "value", $$v)
                  },
                  expression: "permissions.user.value"
                }
              },
              _vm._l(_vm.permissions.user.options, function(perm, key) {
                return _c(
                  "v-radio",
                  {
                    key: key,
                    staticClass: "radio-buttons",
                    attrs: { color: "primary", value: key }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "label-section",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(perm.name))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "desc" }, [
                          _vm._v(_vm._s(perm.description))
                        ])
                      ]
                    )
                  ]
                )
              })
            ),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v("Other Permissions")
            ]),
            _vm._v(" "),
            _vm._l(_vm.permissions.other.options, function(perm, key) {
              return _vm.accessLevel >= perm.accessLevel
                ? _c(
                    "v-checkbox",
                    {
                      key: key,
                      staticClass: "checkboxes",
                      attrs: {
                        "hide-details": "",
                        color: "primary",
                        value: key
                      },
                      model: {
                        value: _vm.permissions.other.value,
                        callback: function($$v) {
                          _vm.$set(_vm.permissions.other, "value", $$v)
                        },
                        expression: "permissions.other.value"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "label-section",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(perm.name))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "desc" }, [
                            _vm._v(_vm._s(perm.description))
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3309d92e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3309d92e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RolePermissions.vue
// module id = 557
// module chunks = 4